import {Map, fromJS, List} from "immutable";

import {
    GET_PURCHASE_ORDERS_SUCCESS,
    GET_PURCHASE_ORDERS_REQUEST,
    GET_PURCHASE_ORDERS_ERROR,

    GET_PURCHASE_ORDER_REQUEST,
    GET_PURCHASE_ORDER_SUCCESS,
    GET_PURCHASE_ORDER_ERROR,

    CREATE_PURCHASE_ORDER_REQUEST,
    CREATE_PURCHASE_ORDER_SUCCESS,
    CREATE_PURCHASE_ORDER_ERROR,

    UPDATE_PURCHASE_ORDER_REQUEST,
    UPDATE_PURCHASE_ORDER_SUCCESS,
    UPDATE_PURCHASE_ORDER_ERROR,

    CHANGE_STATUS_PURCHASE_ORDER_REQUEST,
    CHANGE_STATUS_PURCHASE_ORDER_SUCCESS,
    CHANGE_STATUS_PURCHASE_ORDER_ERROR,

    UPLOAD_PURCHASE_ORDER_FILES_REQUEST,
    UPLOAD_PURCHASE_ORDER_FILES_PROGRESS,
    UPLOAD_PURCHASE_ORDER_FILES_SUCCESS,
    UPLOAD_PURCHASE_ORDER_FILES_ERROR,

    DELETE_PURCHASE_ORDER_FILE_REQUEST,
    DELETE_PURCHASE_ORDER_FILE_SUCCESS,
    DELETE_PURCHASE_ORDER_FILE_ERROR,

    DELETE_PURCHASE_ORDER_REQUEST,
    DELETE_PURCHASE_ORDER_SUCCESS,
    DELETE_PURCHASE_ORDER_ERROR,

    CLEAN_PURCHASE_ORDERS
} from '../actions/purchase-orders';

const purchaseOrders = (state = Map({
  payload: List([]),
  isFetching: false,
    isUploading: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_PURCHASE_ORDERS_REQUEST:
      case GET_PURCHASE_ORDER_REQUEST:
      case CREATE_PURCHASE_ORDER_REQUEST:
      case UPDATE_PURCHASE_ORDER_REQUEST:
      case CHANGE_STATUS_PURCHASE_ORDER_REQUEST:
      case DELETE_PURCHASE_ORDER_FILE_REQUEST:
      case DELETE_PURCHASE_ORDER_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_PURCHASE_ORDER_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_PURCHASE_ORDER_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_PURCHASE_ORDERS_SUCCESS:
      case GET_PURCHASE_ORDER_SUCCESS:
      case CLEAN_PURCHASE_ORDERS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_PURCHASE_ORDER_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_PURCHASE_ORDER_SUCCESS:
      case CHANGE_STATUS_PURCHASE_ORDER_SUCCESS:
      case UPLOAD_PURCHASE_ORDER_FILES_SUCCESS:
      case DELETE_PURCHASE_ORDER_FILE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_PURCHASE_ORDER_SUCCESS:
          updatedPayload = payload.filter( purchaseOrder => {
              return purchaseOrder.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_PURCHASE_ORDERS_ERROR:
      case GET_PURCHASE_ORDER_ERROR:
      case CREATE_PURCHASE_ORDER_ERROR:
      case UPDATE_PURCHASE_ORDER_ERROR:
      case CHANGE_STATUS_PURCHASE_ORDER_ERROR:
      case UPLOAD_PURCHASE_ORDER_FILES_ERROR:
      case DELETE_PURCHASE_ORDER_FILE_ERROR:
      case DELETE_PURCHASE_ORDER_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default purchaseOrders;



// WEBPACK FOOTER //
// ./src/reducers/purchase-orders.js